import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { IntegrationsApiService } from '@core/integrations-http-legacy';
import {
  IntegrationKinds,
  IntegrationsClientConfig,
  IntegrationsCredentials,
} from '@core/integrations-types';
import type { Partner } from '@core/integrations-types';

import { IntegrationKindToken } from './integration-kind.token';
import { PartnerToken } from './partner.token';

@Injectable()
export class ContextualIntegrationsApiService extends IntegrationsApiService {
  constructor() {
    const http = inject(HttpClient);
    const config = inject(IntegrationsClientConfig);
    const integrationsCredentials = inject(IntegrationsCredentials);
    const integrationKind = inject<IntegrationKinds>(IntegrationKindToken);
    const partner = inject<Partner>(PartnerToken);

    super(http, config, integrationsCredentials);

    if (integrationKind) {
      this.context = integrationKind;
    } else if (partner) {
      this.context = `p/${partner.codename}`;
    }
  }
}
